import { Link } from 'react-router-dom';
import { SystemLogo } from '@/components/common';


const footerLinks = {
  platform: {
    title: '平台服务',
    links: [
      { label: '我要发行', href: '/distribution' },
      { label: '需求大厅', href: '/demands' },
      { label: '合作渠道', href: '/distribution#channels' },
    ],
  },
  account: {
    title: '账号中心',
    links: [
      { label: '登录 / 注册', href: '/auth' },
      { label: '个人认证', href: '/certification' },
      { label: '企业认证', href: '/certification' },
      { label: '我的发行项目', href: '/projects' },
    ],
  },
  support: {
    title: '帮助与支持',
    links: [
      { label: '版权合规须知', href: '/distribution#copyright' },
      { label: '发行流程说明', href: '/distribution#workflow' },
      { label: '常见问题', href: '/faq' },
      { label: '联系客服', href: '/contact' },
    ],
  },
};

const channels = [
  { name: 'TikTok', icon: 'ri-music-2-line' },
  { name: '抖音', icon: 'ri-video-line' },
  { name: '微信视频号', icon: 'ri-smartphone-line' },
  { name: '红果短剧', icon: 'ri-play-circle-line' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100 mt-auto">
      <div className="site-shell max-w-7xl px-4 md:px-8">
        {/* Main Footer */}
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center mb-5 cursor-pointer">
              <SystemLogo textClassName="text-white" />
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              一站式 AI 短剧全球代发代运营平台，覆盖 TikTok、抖音、红果等主流渠道，
              提供从内容合规审核到收益结算的完整履约协同链。
            </p>
            {/* Channel Tags */}
            <div className="mt-6 flex flex-wrap gap-2">
              {channels.map((ch) => (
                <span
                  key={ch.name}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-900 text-foreground-300 text-xs"
                >
                  <i className={`${ch.icon} text-primary-500`}></i>
                  {ch.name}
                </span>
              ))}
              <span className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-foreground-900 text-foreground-300 text-xs">
                <i className="ri-earth-line text-primary-500"></i>
                海外自营APP
              </span>
            </div>
          </div>

          {/* Links */}
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 谋势。保留所有权利。
          </p>
          <div className="flex items-center gap-5">
            <Link to="/terms" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              服务条款
            </Link>
            <Link to="/privacy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              隐私政策
            </Link>
            <Link to="/copyright" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              版权声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
